"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Wifi: function() {
        return Wifi;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Wifi = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 6C8.41372 6 5.14445 7.34716 2.66692 9.5646C2.2554 9.93293 1.6232 9.89791 1.25487 9.48638C0.886548 9.07485 0.921569 8.44266 1.3331 8.07433C4.16313 5.54138 7.90276 4 12 4C16.0973 4 19.8369 5.54138 22.6669 8.07433C23.0784 8.44266 23.1135 9.07485 22.7451 9.48638C22.3768 9.89791 21.7446 9.93293 21.3331 9.5646C18.8556 7.34716 15.5863 6 12 6ZM12.0002 11C9.66837 11 7.54566 11.8855 5.94634 13.3403C5.53779 13.7119 4.90533 13.682 4.5337 13.2734C4.16208 12.8649 4.19201 12.2324 4.60056 11.8608C6.55366 10.0842 9.15149 9 12.0002 9C14.849 9 17.4468 10.0842 19.3999 11.8608C19.8084 12.2324 19.8384 12.8649 19.4667 13.2734C19.0951 13.682 18.4627 13.7119 18.0541 13.3403C16.4548 11.8855 14.3321 11 12.0002 11ZM12.0001 16C10.9634 16 10.0208 16.3931 9.30962 17.04C8.90107 17.4116 8.26861 17.3817 7.89699 16.9732C7.52536 16.5646 7.55529 15.9322 7.96384 15.5605C9.02884 14.5918 10.4465 14 12.0001 14C13.5537 14 14.9714 14.5918 16.0364 15.5605C16.4449 15.9322 16.4749 16.5646 16.1032 16.9732C15.7316 17.3817 15.0992 17.4116 14.6906 17.04C13.9794 16.3931 13.0368 16 12.0001 16ZM11 20C11 19.4477 11.4477 19 12 19H12.01C12.5623 19 13.01 19.4477 13.01 20C13.01 20.5523 12.5623 21 12.01 21H12C11.4477 21 11 20.5523 11 20Z",
        fill: "currentColor"
    })
}), "Wifi");
const _default = Wifi;
